// "Staff" — the author is an InsuraCentral admin posting as the company.
export function StaffBadge({ className = "" }: { className?: string }) {
  return (
    <span
      title="InsuraCentral staff"
      className={`fp-inline inline-flex items-center rounded-sm border border-blue-200 bg-blue-50 px-1 py-px align-middle text-[10px] font-semibold uppercase leading-none tracking-[0.08em] text-blue-700 ${className}`}
    >
      Staff
    </span>
  );
}
